import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ApiKeysService, ServiceMeta } from '../../services/api-keys.service';

/** Loads the service catalog and arranges panels; each connection owns its data. */
@Component({
  selector: 'app-configuration-apikeys',
  templateUrl: './apikeys.component.html',
  styleUrls: ['../configuration-list.css', '../service-panels.css', './apikeys.component.css'],
})
export class ConfigurationApiKeysComponent implements OnInit, OnDestroy {
  loading = false;
  error = '';
  connectionMethod: Record<string, 'cli' | 'api'> = {};
  private readonly destroyed$ = new Subject<void>();

  constructor(public store: ApiKeysService) {}
  ngOnInit(): void { this.load(); }
  ngOnDestroy(): void { this.destroyed$.next(); this.destroyed$.complete(); }

  load(): void {
    this.loading = true;
    this.error = '';
    this.store.loadCatalog().pipe(takeUntil(this.destroyed$)).subscribe({
      next: () => { this.loading = false; },
      error: () => { this.loading = false; this.error = 'Could not load services. Please retry.'; },
    });
  }

  /** Sort a copy so other catalog consumers keep the original ordering. */
  get panels(): ServiceMeta[] {
    return this.store.services.filter(service => service.id !== 'Voice').sort((a, b) => Number(b.isAi) - Number(a.isAi));
  }
  trackService(_: number, service: ServiceMeta): string { return service.id; }
  connectionMethodOf(svc: ServiceMeta): 'cli' | 'api' { return this.connectionMethod[svc.id] ?? (svc.hasCliLogin ? 'cli' : 'api'); }
  setConnectionMethod(svc: ServiceMeta, method: 'cli' | 'api'): void { this.connectionMethod[svc.id] = method; }
}
